import { useMemo } from 'react';
import useShiftTypes from './useShiftTypes';
import type { ShiftType } from 'src/api/ShiftTypeService';

const useShiftTypeIdsByShiftCode = (): {
    shiftTypeIdsByShiftCode: Map<string, string>;
    shiftTypes: ShiftType[] | undefined;
    isLoadingShiftTypes: boolean;
} => {
    const { shiftTypes, isLoadingShiftTypes } = useShiftTypes();

    const shiftTypeIdsByShiftCode = useMemo(() => {
        const idsByCode = new Map<string, string>();

        if (shiftTypes) {
            shiftTypes.forEach((shiftType) =>
                idsByCode.set(shiftType.code, shiftType.id),
            );
        }

        return idsByCode;
    }, [shiftTypes]);

    return { shiftTypeIdsByShiftCode, shiftTypes, isLoadingShiftTypes };
};

export default useShiftTypeIdsByShiftCode;
